import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedSection from './components/FeaturedSection';
import LatestSection from './components/LatestSection';
import RankingSection from './components/RankingSection';
import EditorPickSection from './components/EditorPickSection';
import FAQSection from './components/FAQSection';
import { siteInfo } from '@/mocks/webtoons';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        foundingDate: siteInfo.foundingYear,
      },
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        url: siteInfo.url,
        description: siteInfo.description,
        potentialAction: {
          '@type': 'SearchAction',
          target: {
            '@type': 'EntryPoint',
            urlTemplate: `${siteInfo.url}/category/all?q={search_term_string}`,
          },
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: '韩漫网首页 - 在线免费阅读韩国漫画大全',
        description: siteInfo.description,
        url: siteInfo.url,
        isPartOf: {
          '@type': 'WebSite',
          name: siteInfo.name,
          url: siteInfo.url,
        },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <HeroSection />
      <CategoryNav />
      <FeaturedSection />
      <LatestSection />
      <RankingSection />
      <EditorPickSection />
      <FAQSection />
    </>
  );
}